App.vue.setComponent(require('@components/Catalog/CatalogPageTopBanner.vue').default);
App.vue.setComponent(require('@components/Catalog/Catalog.vue').default);
App.vue.setComponent(require('@components/Stocks/StocksCard/StocksCardCounter.vue').default);
App.vue.setComponent(require('@components/bootstrap/SearchEngine.vue').default);
App.vue.setComponent(require('@components/sliders/CheckedGoods.vue').default);
